import React, { useState } from "react";
import {
  CheveronArrowRightIcon,
  CheveronArrowLeftIcon,
  CalendarIcon,
} from "../icons"; // Updated arrow icons import
import { ImgTopBtn } from "../buttons";
import "./yearWeekPicker.scss";

function YearWeekPicker({
  initialYear = new Date().getFullYear(),
  initialWeek = 1,
  onApply,
}) {
  const [year, setYear] = useState(initialYear);
  const [week, setWeek] = useState(initialWeek);

  // Increase or decrease the year
  const incrementYear = () => setYear((prev) => prev + 1);
  const decrementYear = () => setYear((prev) => prev - 1);

  // Increase or decrease the week (wrap around from 1 to 52)
  const incrementWeek = () => setWeek((prev) => (prev < 52 ? prev + 1 : 1));
  const decrementWeek = () => setWeek((prev) => (prev > 1 ? prev - 1 : 52));

  // Confirm selection and pass back the chosen values.
  const handleApply = () => {
    onApply({ year, week });
  };

  return (
    <div className="year-week-picker-container">
      <div className="year-week-picker-header">
        <h3>Select Year &amp; Week</h3>
      </div>
      {/* Year Selector */}
      <div className="selector-row year-selector">
        <button className="arrow-btn" onClick={decrementYear}>
          <CheveronArrowLeftIcon width="24" height="24" />
        </button>
        <span className="value-display">{year}</span>
        <button className="arrow-btn" onClick={incrementYear}>
          <CheveronArrowRightIcon width="24" height="24" />
        </button>
      </div>

      {/* Week Selector */}
      <div className="selector-row week-selector">
        <button className="arrow-btn" onClick={decrementWeek}>
          <CheveronArrowLeftIcon width="24" height="24" />
        </button>
        <span className="value-display">Week {week}</span>
        <button className="arrow-btn" onClick={incrementWeek}>
          <CheveronArrowRightIcon width="24" height="24" />
        </button>
      </div>

      <div className="year-week-picker-footer">
        <ImgTopBtn
          id="pply Ranking Filters"
          image={
            <CalendarIcon
              style={{
                marginRight: "5px",
              }}
              width="20px"
              height="20px"
            />
          } // This now correctly sets the size
          imgTopBtnBorderRadius="25px"
          imgTopBtnText="Apply Period"
          imgTopBtnWidth="fit-content"
          imgTopBtnTextFontSize="1.3rem"
          extraImgTopBtnStyles={{
            padding: "5px",
          }}
          imgTopBtnnFontFamily="Roboto-Slab"
          imgTopBtnFontWeight="900"
          imgTopBtnFontColor="var(--color-bloodred)"
          onClick={handleApply}
        />
      </div>
    </div>
  );
}

export default YearWeekPicker;
